import { render, staticRenderFns } from "./WebNotificationsModal.vue?vue&type=template&id=44bf2c2a&scoped=true&"
import script from "./WebNotificationsModal.vue?vue&type=script&lang=js&"
export * from "./WebNotificationsModal.vue?vue&type=script&lang=js&"
import style0 from "./WebNotificationsModal.vue?vue&type=style&index=0&id=44bf2c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bf2c2a",
  null
  
)

export default component.exports